import styled from "styled-components";
import variables from "../../theme/variables";
export const PostContainer = styled.div`
  margin-bottom: 32px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  .post-data {
    position: absolute;
    bottom: -12px;
    background: rgb(0, 0, 0);
    background: linear-gradient(
      360deg,
      rgba(0, 0, 0, 1) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    padding: 32px 16px 32px 16px;
    width: 100%;
    z-index: 2;
    h2 {
      margin-bottom: 8px;
    }
    span {
      font-size: 14px;
    }
  }
  img {
    width: 100%;
    height: auto;
  }
  .cover {
    width: 100%;
    height: 100%;
    position: absolute;
    content: "";
    z-index: 1;
    top: 0;
    left: 0;
    background-position: center;
    background-size: 100%;
    background-repeat: no-repeat;
    transition: 0.7s all;
  }
  &:hover {
    .cover {
      background-size: 102%;
    }
  }
`;
